import store from '../stores'

const insereGoogleRecaptcha = (VUE_APP_GOOGLE_RECAPTCHA_KEY) => {
    const key = VUE_APP_GOOGLE_RECAPTCHA_KEY;
    let recaptcha = document.getElementById('captcha')
    if(recaptcha) {
      window.grecaptcha = null
      recaptcha.parentElement.removeChild(recaptcha)
    }
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute('id', 'captcha')
    recaptchaScript.setAttribute(
      "src",
      `https://www.google.com/recaptcha/api.js?render=${key}`
    );
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    document.head.appendChild(recaptchaScript);

    recaptchaScript.onload = async () => {
      let token = await recaptchaToken(key)
      store.dispatch('gravaToken', token)
    };
}

const recaptchaToken = (key) => {    
    return new Promise((resolve) => {      
      const chave = key;
      window.grecaptcha.ready(async () => {
        const token = await window.grecaptcha.execute(chave);        
        resolve(token);
      });
    });
  }

export async function getEnv(){
  try{
    let resultado = await fetch("/env.json",{
      mode:"no-cors"
    });
    return resultado.json();
  }
  catch(error)
  {
    return error;
  }
}

export { insereGoogleRecaptcha, recaptchaToken }
export default { insereGoogleRecaptcha, recaptchaToken, getEnv }